import { render, staticRenderFns } from "./DevTickets.vue?vue&type=template&id=f3fbe910&scoped=true&"
import script from "./DevTickets.vue?vue&type=script&lang=js&"
export * from "./DevTickets.vue?vue&type=script&lang=js&"
import style0 from "./DevTickets.vue?vue&type=style&index=0&id=f3fbe910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fbe910",
  null
  
)

export default component.exports